"use client";

// AppleEmoji — one emoji, drawn with Apple's artwork (PNG via jsdelivr) so it
// reads the same on every platform. Falls through the candidate URLs (with /
// without FE0F) and lands on the native glyph only if the CDN has no image.

import { useEffect, useMemo, useState, type CSSProperties } from "react";
import { appleEmojiUrls } from "../../lib/os/appleEmoji";

export default function AppleEmoji({
  emoji,
  size,
  style,
}: {
  emoji: string;
  /** css size (number = px, or any length expression). */
  size: number | string;
  style?: CSSProperties;
}) {
  const urls = useMemo(() => appleEmojiUrls(emoji), [emoji]);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => setAttempt(0), [emoji]);
  const dim = typeof size === "number" ? `${size}px` : size;
  if (attempt >= urls.length) {
    // no Apple art for this char — the native glyph is better than nothing.
    return <span style={{ fontSize: dim, lineHeight: 1, ...style }}>{emoji}</span>;
  }
  return (
    // eslint-disable-next-line @next/next/no-img-element -- tiny cross-origin CDN sprite; next/image adds nothing here
    <img
      src={urls[attempt]}
      alt=""
      aria-hidden
      draggable={false}
      onError={() => setAttempt((a) => a + 1)}
      style={{ display: "block", width: dim, height: dim, objectFit: "contain", ...style }}
    />
  );
}
